import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X, User, LogOut } from 'lucide-react';
import { useState } from 'react';

export default function Navbar({ user, onLogout }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="glass-nav border-b border-black/5 sticky top-0 z-50">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="text-xl tracking-tight" style={{ fontFamily: 'Space Grotesk, sans-serif', fontWeight: 700 }} data-testid="nav-logo">
            Mid2Mint
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/build-choice" className="text-sm font-normal text-muted-foreground hover:text-foreground transition-colors" data-testid="nav-builder-link">
              Build
            </Link>
            <Link to="/custom-build" className="text-sm font-normal text-muted-foreground hover:text-foreground transition-colors" data-testid="nav-custom-build-link">
              Custom
            </Link>
            <Link to="/gallery" className="text-sm font-normal text-muted-foreground hover:text-foreground transition-colors" data-testid="nav-gallery-link">
              Gallery
            </Link>
            <Link to="/services" className="text-sm font-normal text-muted-foreground hover:text-foreground transition-colors" data-testid="nav-services-link">
              Services
            </Link>
            {user ? (
              <>
                <Link to="/dashboard" className="text-sm font-normal text-muted-foreground hover:text-foreground transition-colors" data-testid="nav-dashboard-link">
                  Dashboard
                </Link>
                {user.is_admin && (
                  <Link to="/admin" className="text-sm font-normal text-muted-foreground hover:text-foreground transition-colors" data-testid="nav-admin-link">
                    Admin
                  </Link>
                )}
                <Button
                  onClick={onLogout}
                  variant="ghost"
                  size="sm"
                  className="rounded-full text-muted-foreground hover:text-foreground"
                  data-testid="nav-logout-btn"
                >
                  <LogOut className="w-4 h-4" strokeWidth={1.5} />
                </Button>
              </>
            ) : (
              <Link to="/auth">
                <Button className="rounded-full h-9 px-5 text-sm btn-scale" size="sm" data-testid="nav-login-btn">
                  <User className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.5} />
                  Login
                </Button>
              </Link>
            )}
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden text-muted-foreground"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="nav-mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-5 h-5" strokeWidth={1.5} /> : <Menu className="w-5 h-5" strokeWidth={1.5} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-6 border-t border-black/5" data-testid="nav-mobile-menu">
            <div className="flex flex-col gap-4">
              <Link to="/build-choice" className="text-sm text-muted-foreground" onClick={() => setMobileMenuOpen(false)} data-testid="nav-mobile-builder-link">
                Build
              </Link>
              <Link to="/custom-build" className="text-sm text-muted-foreground" onClick={() => setMobileMenuOpen(false)} data-testid="nav-mobile-custom-build-link">
                Custom
              </Link>
              <Link to="/gallery" className="text-sm text-muted-foreground" onClick={() => setMobileMenuOpen(false)} data-testid="nav-mobile-gallery-link">
                Gallery
              </Link>
              <Link to="/services" className="text-sm text-muted-foreground" onClick={() => setMobileMenuOpen(false)} data-testid="nav-mobile-services-link">
                Services
              </Link>
              {user ? (
                <>
                  <Link to="/dashboard" className="text-sm text-muted-foreground" onClick={() => setMobileMenuOpen(false)} data-testid="nav-mobile-dashboard-link">
                    Dashboard
                  </Link>
                  {user.is_admin && (
                    <Link to="/admin" className="text-sm text-muted-foreground" onClick={() => setMobileMenuOpen(false)} data-testid="nav-mobile-admin-link">
                      Admin
                    </Link>
                  )}
                  <Button
                    onClick={() => { onLogout(); setMobileMenuOpen(false); }}
                    variant="outline"
                    size="sm"
                    className="rounded-full w-full"
                    data-testid="nav-mobile-logout-btn"
                  >
                    Logout
                  </Button>
                </>
              ) : (
                <Link to="/auth" onClick={() => setMobileMenuOpen(false)}>
                  <Button className="rounded-full w-full" size="sm" data-testid="nav-mobile-login-btn">
                    Login
                  </Button>
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
